<span class="text-primary text-4xl font-bold z-40" [class]="classes">Awread</span>